/* eslint-disable max-lines */
import type React from 'react';
import type { DSControlledDateTimePickerT } from './react-desc-prop-types.js';

export declare namespace DSControlledDateTimePickerInternalsT {
  export type DateDay =
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27
    | 28
    | 29
    | 30
    | 31;
  export type DateMonth = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
  export type OnKeyDown<HTMLT = HTMLInputElement> = (e: React.KeyboardEvent<HTMLT>) => void;
  export type OnChangeFunc = (e: React.ChangeEvent<HTMLInputElement>) => void;
  export type OnDSBtnClick = (
    e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement> | React.KeyboardEvent,
  ) => void;
  export type HandleOnChangeFunc = (
    newVal: string,
    e: DSControlledDateTimePickerT.OnInternalValuesChangeEvent,
    metaInfo?: DSControlledDateTimePickerT.InternalInputsChangeMetaInfo,
  ) => void;
  export type OnBlurFunc = (e: React.FocusEvent<HTMLInputElement>) => void;
  export type OnFocusFunc = (e: React.FocusEvent<HTMLInputElement>) => void;

  export interface UseDateInputsR {
    month: string;
    day: string;
    year: string;
    autoFocusMonthInput: boolean;
    innerRefMonthInput?:
      | React.MutableRefObject<HTMLInputElement | HTMLButtonElement | null>
      | ((ref: HTMLInputElement | HTMLButtonElement | null) => void);
    disabled: boolean;
    applyAriaDisabled?: boolean;
    onMonthChange: OnChangeFunc;
    onDayChange: OnChangeFunc;
    onYearChange: OnChangeFunc;
    onMonthFocus: OnFocusFunc;
    onDayFocus: OnFocusFunc;
    onYearFocus: OnFocusFunc;
    onMonthBlur: OnBlurFunc;
    onDayBlur: OnBlurFunc;
    onYearBlur: OnBlurFunc;
    onMonthKeyDown: OnKeyDown;
    onDayKeyDown: OnKeyDown;
    onYearKeyDown: OnKeyDown;
  }
  export interface InputsReferences {
    monthInputRef: React.RefObject<HTMLInputElement>;
    dayInputRef: React.RefObject<HTMLInputElement>;
    yearInputRef: React.RefObject<HTMLInputElement>;
    hourInputRef: React.RefObject<HTMLInputElement>;
    minutesInputRef: React.RefObject<HTMLInputElement>;
    meridiemInputRef: React.RefObject<HTMLInputElement>;
    clearButtonRef: React.MutableRefObject<HTMLButtonElement>;
    pickerButtonRef: React.MutableRefObject<HTMLButtonElement>;
  }
  export interface CalendarReferences {
    prevYearBtnRef: React.MutableRefObject<HTMLButtonElement>;
    prevMonthBtnRef: React.MutableRefObject<HTMLButtonElement>;
    nextMonthBtnRef: React.MutableRefObject<HTMLButtonElement>;
    nextYearBtnRef: React.MutableRefObject<HTMLButtonElement>;
    calendarDaysWrapperRef: React.MutableRefObject<HTMLDivElement>;
  }
  export interface TimewheelReferences {
    prevHourBtnRef: React.MutableRefObject<HTMLButtonElement>;
    currHourBtnRef: React.MutableRefObject<HTMLButtonElement>;
    nextHourBtnRef: React.MutableRefObject<HTMLButtonElement>;
    prevMinutesBtnRef: React.MutableRefObject<HTMLButtonElement>;
    currMinutesBtnRef: React.MutableRefObject<HTMLButtonElement>;
    nextMinutesBtnRef: React.MutableRefObject<HTMLButtonElement>;
    prevMeridiemBtnRef: React.MutableRefObject<HTMLButtonElement>;
    currMeridiemBtnRef: React.MutableRefObject<HTMLButtonElement>;
    nextMeridiemBtnRef: React.MutableRefObject<HTMLButtonElement>;
  }
  export interface InternalPrecalculatedFlags {
    isControllerOnly: boolean;
    shouldPreserveClearableSpace: boolean;
    isWithTimeWheelToo: boolean;
    isWithCalendarToo: boolean;
    isWithDateInputs: boolean;
    isWithDateInputsOnly: boolean;
    isWithTimeInputs: boolean;
    isWithTimeInputsOnly: boolean;
    autoFocusMonthInput: boolean;
    autoFocusHourInput: boolean;
    autoFocusPrevMonthArrow: boolean;
    autoFocusHourTimeWheel: boolean;
    hideDate: boolean;
    hideTime: boolean;
    hideDateTimePicker: boolean;
    hideDatePicker: boolean;
    hideTimePicker: boolean;
    withAnyInputs: boolean;
    withAnyPicker: boolean;
    withClearBtn: boolean;
    withAnyRightController: boolean;
    isDateSelector: boolean;
    isTimeSelector: boolean;
    isDateTimeSelector: boolean;
  }
}
